<template>
<v-dialog v-model="onbehalf" persistent max-width="600">
    <v-card>
        <v-system-bar color="primary" dark>
            <v-spacer></v-spacer>
            <v-icon v-if="$route.name != 'empty'" @click="setOnbehalfDialog(false)">mdi-close</v-icon>
        </v-system-bar>
        <v-card-title>Вхiд від імені Клієнта</v-card-title>
        <v-card-text>
            <div>Вкажіть Клієнта, від імені якого Ви будете знаходитися на В2В-порталі</div>
            <v-autocomplete clearable cache-items v-model="onbehalfF.client" label="Клієнт" @change="getContacts(onbehalfF.client)" hide-no-data persistent-hint :items="itemsClients" :loading="isLoading" :search-input.sync="searchClients"></v-autocomplete>
            <v-select clearable prepend-icon="mdi-account" v-model="onbehalfF.contact" persistent-hint hide-no-data :items="itemsContacts" :loading="isLoadingContacts" label="Контакт Клієнта">
                <template v-slot:item="{ item }">
                    <v-list-item-content :class="item.hasPortalAccess ? '' : 'grey--text'">
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                        <v-list-item-subtitle v-if="!item.hasPortalAccess">Немає доступу до порталу</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                        <v-icon :color="item.hasPortalAccess ? 'success' : 'grey'">
                            {{ item.hasPortalAccess ? 'mdi-account-check' : 'mdi-account-off' }}
                        </v-icon>
                    </v-list-item-icon>
                </template>
            </v-select>
        </v-card-text>
        <v-card-actions>
            <v-btn v-if="$route.name != 'empty'" color="" text @click="setOnbehalfDialog(false)">
                Скасувати
            </v-btn>
            <!-- {{onbehalfF}} -->
            <v-spacer></v-spacer>
            <v-btn :disabled="onbehalfF.contact ? false : true" color="primary" text @click="goOnbehalf()">
                Увійти
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex'

export default {
    data: () => ({
        onbehalfF: {
            client: null,
            contact: null,
        },
        itemsClients: [],
        itemsContacts: [],
        searchClients: null,
        isLoading: false,
        isLoadingContacts: false,
    }),
    methods: {
        ...mapActions(['getClientsAutocomplete', 'getContactsAutocomplete', 'setOnbehalf']),
        queryClientsSelections(v) {
            this.isLoading = true
            this.itemsContacts = []
            this.getClientsAutocomplete(v)
                .then((data) => {
                    this.itemsClients = data.filter(e => {
                        return (e.text || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
                    })
                    this.isLoading = false
                })
                .catch(err => console.log(err))
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        getContacts(v, selectedContact = null) {
            this.onbehalfF.contact = null
            this.itemsContacts = []

            if (!v) {
                return
            }

            this.isLoadingContacts = true
            this.getContactsAutocomplete(v)
                .then((data) => {
                    this.itemsContacts = data
                    if (selectedContact && data.some(item => item.value == selectedContact)) {
                        this.onbehalfF.contact = selectedContact
                    }
                    this.isLoadingContacts = false
                })
                .catch(err => {
                    this.isLoadingContacts = false
                    console.log(err)
                })
        },
        setCurrentValues() {
            const client = this.contactInfo && this.contactInfo.clientId
            const contact = this.contactInfo && this.contactInfo.contactId

            if (!client || client < 0) {
                return
            }

            const contractorName = (this.contactInfo.contractorName || '').trim()
            const currentClient = {
                value: client,
                text: this.contactInfo.clientName + (contractorName ? ` (${contractorName})` : ''),
            }
            const currentClientIndex = this.itemsClients.findIndex(item => item.value == client)
            if (currentClientIndex === -1) {
                this.itemsClients.unshift(currentClient)
            } else {
                this.$set(this.itemsClients, currentClientIndex, {
                    ...this.itemsClients[currentClientIndex],
                    ...currentClient,
                })
            }

            this.onbehalfF.client = client
            this.getContacts(client, contact)
        },
        setOnbehalfDialog(v) {
            this.$store.commit('setOnbehalfDialog', v)
        },
        goOnbehalf() {
            this.setOnbehalf(this.onbehalfF)
                .then(() => {
                    this.setOnbehalfDialog(false)
                    this.setLocalStorage('shoppingCart', [])
                    window.location = '/'
                })
                .catch(error => console.log(error))
        }
    },
    computed: {
        contactInfo() {
            return this.$store.state.main.contactInfo
        },
        onbehalf() {
            return this.$store.state.main.onbehalfDialog
        }
    },
    watch: {
        onbehalf(val) {
            if (val) {
                this.setCurrentValues()
            }
        },
        searchClients(val) {
            val && val !== this.onbehalfF.client && this.queryClientsSelections(val)
        },
    },
}
</script>
